import axiosInstance from './axiosInstance';

export const submitFeedback = async (name, email, content) => {
  const response = await axiosInstance.post('/feedbacks', {
    name,
    email,
    content,
  });
  return response.data;
};
